export default __webpack_public_path__ + "static/Moderat-Mono-Bold-2da6a35b4299b094128ecce7bdf60eec.woff2";